/**
 * 恆遠會員中樞的網址（網域固定，預設值直接寫死以免還要設環境變數；要換站台再用 env 覆蓋）
 */

/** 帳號設定頁（已有密碼的人在這裡改密碼） */
export const HUB_ACCOUNT_URL: string =
  import.meta.env.VITE_HUB_ACCOUNT_URL || 'https://go.foreverwebs.com/settings'

/** 忘記密碼頁：只用 Google 登入、還沒有密碼的帳號也從這裡設定一組密碼 */
export const HUB_FORGOT_PASSWORD_URL: string =
  import.meta.env.VITE_HUB_FORGOT_PASSWORD_URL || 'https://go.foreverwebs.com/forgot-password'

/** 帳號設定的「安全性」分頁：開啟兩步驟驗證、重新產生備用碼都在這裡 */
export const HUB_SECURITY_SETTINGS_URL: string = withTab(HUB_ACCOUNT_URL, 'security')

function withTab(base: string, tab: string): string {
  try {
    const url = new URL(base)
    url.searchParams.set('tab', tab)
    return url.toString()
  } catch {
    return `${base}${base.includes('?') ? '&' : '?'}tab=${tab}`
  }
}
